var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { IndicatorBlockLayout } from '../entities/indicator-block-layout';
import { SvgRingChart } from '../elements/svg-ring-chart';
import { useView } from '../hooks/use-view';
var cls = classNames('indicator-layout-ring-chart');
var IndicatorLayoutRingChartDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: ", ";\n  "])), theme.UNIT(5)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    gap: ", ";\n  "], ["\n    gap: ", ";\n  "])), theme.UNIT(8))
});
var IndicatorBlockStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SvgRingChartStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorLayoutRingChart',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IndicatorBlock: styled(IndicatorBlockLayout)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IndicatorBlockStyles),
  SvgRingChart: styled(SvgRingChart)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SvgRingChartStyles)
};
export var IndicatorLayoutRingChart = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorLayoutRingChartDefaultProps, props);
  var className = componentProps.className,
    entity = componentProps.entity;
  var result = entity.result;
  var activeView = useView(entity.path, 'overview').activeView;
  var animate = activeView === 'overview';
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.IndicatorBlock, {
    entity: entity
  }), React.createElement(My.SvgRingChart, {
    animate: animate,
    style: {
      width: '140px',
      height: '140px'
    },
    value: result === null || result === void 0 ? void 0 : result.numericValue
  }));
};
IndicatorLayoutRingChart.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;